import FontIcon from "react-toolbox/lib/font_icon";
import React from "react";
import SemiCircle from "../../../HighCharts/SemiCircle";
// import {PulseLoader} from "halogen";


export const TopDashboard = props => {

    let data;

    if (props.stations.length > 0) {

        let count = [0, 0, 0];
        let total;

        props.stations.forEach(item => {
            switch (item.status.value) {
                case "active":
                    count[0]++;
                    break;
                case "idle":
                    count[1]++;
                    break;
                default:
                    count[2]++;
                    break;
            }
        });

        total = count[0] + count[1] + count[2];

        data = [['active', count[0] * 100 / total], ['idle', count[1] * 100 / total], ['disabled', count[2] * 100 / total]];
    }

    return (
        <div className={'row'}>
            <div className="col-xs-4 nodeContent ">
                <div className={'stationControlContainer'}>

                    <h4 className={'stationControlTitle'}>
                        <FontIcon className={'stationControlIcon'}
                                  value='pie_chart'/>Station Status
                    </h4>

                    {props.content ?
                        <SemiCircle className={'stationControlChart'}
                                    data={data}/>
                        :
                        null
                        // <PulseLoader className="LoadTable"
                        //              color="#0A2A59"
                        //              size={"20px"}
                        //              margin={"4px"}/>}
                    }
                </div>
            </div>
            <div className="col-xs-4 nodeContent">
                <div className="stationControlContainer">
                    {/*{this.handleChart()}*/}
                </div>
            </div>
            <div className="col-xs-4 nodeContent">
                <div className="stationControlContainer">
                    {/*{this.handleChart()}*/}
                </div>
            </div>
        </div>
    );

};


// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminStations/StationList/topCharts.js